import ToolTip from "../../../../../../parts/tooltip-portal";
import { DATE_FORMATS } from "../../../../../../constants";
import SvgIcon from "../../../../../../parts/SvgIcon";
import { PasteExerciseComponent } from "../../../../../../parts/PasteExerciseComponent";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

const Footer = ({
  date,
  editDayMode,
  handleRemoveMultiple,
  resetExercises,
  saveEditedExercise,
  hasExercise = false,
  athleteId,
  toggleEditDayMode,
  outcomesExist,
  exercisesInClipboard,
  athlete,
  exercises,
}) => {
  const highestOrder =
    !exercises || exercises?.length === 0
      ? 0
      : Math.max(...exercises.map(({ order }) => order ?? 0));

  return (
    <footer>
      {editDayMode ? (
        <div className="button-group">
          <button
            data-button-type="secondary"
            className="!text-[--danger]"
            onClick={() => resetExercises()}
          >
            Discard
          </button>
          <button
            data-button-type="primary"
            onClick={() => saveEditedExercise(athleteId)}
          >
            Save
          </button>
        </div>
      ) : outcomesExist ? (
        <span className="uneditable-workout-text">
          You cannot edit workouts with outcomes
        </span>
      ) : (
        <>
          <a
            href={`/actions/refresh?modal[type]=calendar-add-exercise&day=${date.format(
              DATE_DAY_FORMAT
            )}`}
            data-button-type="text"
            role="button"
          >
            <SvgIcon
              src="/img/new-icons/add-gradient-icon.svg"
              className="h-5 w-5"
              noFilterOnLight={true}
            />
            <span className="font-semibold">Add Exercise</span>
          </a>
          {hasExercise ? (
            <div className="flex items-center gap-1">
              <PasteExerciseComponent
                athlete={athlete}
                date={date.format(DATE_DAY_FORMAT)}
                query={exercisesInClipboard}
                haveExercises={true}
                exercisesLength={exercises?.length}
                highestOrder={highestOrder}
              />
              <ToolTip id="edit-exercises" body="Quick Edit">
                <a
                  onClick={() => {
                    toggleEditDayMode();
                  }}
                  href="#_"
                  data-button-type="secondary"
                  role="button"
                >
                  <SvgIcon src="/img/new-icons/edit-pencil.svg" />
                </a>
              </ToolTip>
              <ToolTip id="duplicate-exercises" body="Duplicate Workout">
                <a
                  href={`/actions/refresh?modal[type]=calendar-duplicate-workout&day=${date.format(
                    DATE_DAY_FORMAT
                  )}`}
                  data-button-type="secondary"
                  role="button"
                >
                  <SvgIcon src="/img/new-icons/duplicate.svg" />
                </a>
              </ToolTip>
              <ToolTip id="delete-exercises" body="Delete all exercises">
                <a
                  href="#"
                  onClick={(e) => handleRemoveMultiple(e, date)}
                  data-button-type="secondary"
                  role="button"
                >
                  <img src="/img/new-icons/red-trash.svg" alt="remove" />
                </a>
              </ToolTip>
            </div>
          ) : null}
        </>
      )}
    </footer>
  );
};

export default Footer;
